export default __webpack_public_path__ + "static/media/left-arrow.6fa8d62e.svg";